import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
//import { WarehouseIcon } from "./Icons/WarehouseIcon";
import { PlayIcon } from "./Icons/PlayIcon";
import { PauseIcon } from "./Icons/PauseIcon";
import { TimeIcon } from "./Icons/TimeIcon";
import { useUser } from "../Context/UserProvider";
import { Shift, patrollerService } from "../Api/Services/PatrollerService";
import { useInfoModal } from "../Context/InfoModalProvider";
import {ModalSuccessIcon} from "./Icons/ModalSuccessIcon";
import {CheckIconCircle} from "./Icons/CheckIconCircle";

const DailyInfo: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const { user } = useUser();
    const  { showInfo } = useInfoModal();

    const [shiftData, setShiftData] = useState<Shift | null>(null);
    const [elapsedSeconds, setElapsedSeconds] = useState<number>(0);
    const [lastShiftSeconds, setLastShiftSeconds] = useState<number>(0);
    const [isCounting, setIsCounting] = useState<boolean>(false);

    const fetchShiftData = async () => {
        try {
            const data = await patrollerService.getSift();
            setShiftData(data);
        } catch (error) {
            console.error("Hiba történt a Shift adatok lekérése során:", error);
        }
    };

    useEffect(() => {
        fetchShiftData();
    }, []);

    useEffect(() => {
        if (shiftData) {
            setElapsedSeconds(parseInt(shiftData.totalSeconds) || 0);
            setLastShiftSeconds(parseInt(shiftData.lastShift) || 0);
            setIsCounting(shiftData.inShift);
        }
    }, [shiftData]);

    useEffect(() => {
        let timer: NodeJS.Timeout | null = null;

        if (isCounting) {
            timer = setInterval(() => {
                setElapsedSeconds((prev) => prev + 1);
                setLastShiftSeconds((prev) => prev + 1);
            }, 1000);
        }

        return () => {
            if (timer) clearInterval(timer);
        };
    }, [isCounting]);

    const handleClockIn = async () => {
        try {
            await patrollerService.getClockInData();
            await fetchShiftData();
            setIsCounting(true);
            showInfo(
                <>
                    <div className="flex justify-center mb-2"><ModalSuccessIcon /></div>
                    <div className="text-center">{t("Shift successfully started!")}</div>
                </>
            );
            //setLastShiftSeconds(1);
        } catch (error) {
            console.error("Hiba történt a Clock In során:", error);
        }
    };

    // Műszak leállítása
    const handleClockOut = async () => {
        try {
            await patrollerService.getClockOutData();
            await fetchShiftData();
            setIsCounting(false);
            showInfo(
                <>
                    <div className="flex justify-center mb-2"><ModalSuccessIcon /></div>
                    <div className="text-center">{t("Shift successfully stopped!")}</div>
                </>
            );
        } catch (error) {
            console.error("Hiba történt a Clock Out során:", error);
        }
    };

    // Idő formázása (HH:MM:SS)
    const formatTime = (totalSeconds: number) => {
        const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, "0");
        const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, "0");
        const seconds = (totalSeconds % 60).toString().padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
    };

    return (
        <div className="daily-info card">
            <div className="heading-large mb-0">{user?.name || "Guest"}</div>
            {/* <div className="text-secondary flex gap-2 align-center">
                <WarehouseIcon />
                {user?.fleet_partner_name || "Star Manpower"}
            </div>*/}
            <div className="separator-line"></div>

            {/* Összes ledolgozott idő */}
            <div className="total-worked-today mb-4">
                <div className="flex justify-between items-center">
                    <div>
                        <div className="total-worked-today__heading">
                            {t('Total worked today')}
                        </div>
                        <div className="total-worked-today__timer">{formatTime(elapsedSeconds)}</div>
                    </div>
                    <div className="total-worked-today__button">
                        {isCounting ? (
                            <button onClick={handleClockOut}>
                                <PauseIcon />
                            </button>
                        ) : (
                            <button onClick={handleClockIn}>
                                <PlayIcon />
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Műszak információk */}
            <div className="flex gap-4">
                <div className="daily-info__short-info">
                    <TimeIcon />
                    {formatTime(lastShiftSeconds)}
                </div>
                {/*<div className="daily-info__short-info">
                    <MopedIcon />
                    {shiftData?.served_rider}
                </div>*/}
                <div className="daily-info__short-info">
                    <CheckIconCircle />
                    {user?.todayCheck}
                </div>
            </div>
        </div>
    );
};

export default DailyInfo;